<template>
    <div class="cover">
        <div class="bookmark"><i class="icon-right-arrow"></i></div>
        <div class="lock-down">
            <div class="title">Fai una stima della tua spesa con Link.</div>
            <p>Bastano pochi passaggi per calcolare una stima di quanto spenderai con la nostra offerta gas e luce più conveniente.</p>
            <button class="sf2-btn" @click="next()">Calcola il tuo <strong>PREVENTIVO</strong></button>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Cover",
        props: {
        },
        data() {
            return {
                
            };
        },
        mounted() {
            console.log('Cover mounted');
        },
        computed: {

        },
        methods: {
            next() {
                console.log( 'Cover emit onNext' );

                this.$emit( 'onNext', {} );
            }
        },
    };
</script>

<style scoped lang="scss">

    .cover {
        @media (max-width: 1023px) {
            height: 215px !important;
        }
    }

    .bookmark {
        width: 96px; height: 110px; position: absolute; right: 30px; top: 0;

        @media (max-width: 1023px) {
            display: none;
        }

        &::before { background: #ffd300;  border-radius: 0 0 5px 5px; }

        i {top: 15px; position: relative; font-size: 40px;}
    }

    .title { font-size: 40px; line-height: 48px; margin-bottom: 15px; font-weight: bold; 
        @media (max-width: 1023px) {
            font-size: 30px; line-height: 38px;
        }
    }
    p { font-size: 16px; line-height: 22px; margin-bottom: 15px; 
        @media (max-width: 1023px) {
            display: none;
        }
    }
    button {
        @media (max-width: 1023px) {
            margin-top: 30px;
        }
    }

</style>